// extracted by mini-css-extract-plugin
module.exports = {"MenuToggle":"MenuToggle_MenuToggle__yuRDd","open":"MenuToggle_open__sV1iK"};